/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 11/07/2024 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Protección anti doble click en acciones críticas
* ---------------------------------------------------------------------------------------
*/

import { IconButton, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import DirectionsIcon from "@mui/icons-material/Directions";
import VerifiedIcon from "@mui/icons-material/Verified";
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import DensitySmallIcon from '@mui/icons-material/DensitySmall';
import RefreshIcon from "@mui/icons-material/Refresh";
import PrintIcon from '@mui/icons-material/Print';
import HomeIcon from '@mui/icons-material/Home';

import { Fragment, useEffect, useCallback } from "react";
import { useSesion } from "../../context/System/SesionContext";
import { useVentas } from "../../context/Ventas/VentasContext";
import { useDoubleClickPrevention } from "../../hooks/useDoubleClickPrevention";

export default function MnuAplicarDescuento() {
    const { getPermisoBoton, getNombreBoton, getStatusPath, parametrosCajaForm} = useSesion();
    const {
        setStatusAbrirDescuentos,
        handleAplicarDescuentosManual,
        handleClickRefrescarDatosDescuentos,
        setStatusKeyActions,
    } = useVentas();
    const { isProcessing, executeWithProtection } = useDoubleClickPrevention();

    const handleCerrarDescuentos=()=>{
        setStatusAbrirDescuentos(false);
        setStatusKeyActions(false);
    };
    
    return (
        <Fragment>
            <Tooltip title={"Cerrar descuentos"}>
                <IconButton onClick={handleCerrarDescuentos}>
                    <HomeIcon className="icon" /><p className="icon">Cerrar descuentos</p>
                </IconButton>
            </Tooltip>
            <Tooltip title={"Aplicar"}>
                <IconButton onClick={() => executeWithProtection(handleAplicarDescuentosManual)} disabled={isProcessing}>
                    <SaveAltIcon className="icon" /><p className="icon">Aplicar</p>
                </IconButton>
            </Tooltip>
            <Tooltip title="Refrescar datos">
                <IconButton onClick={() => executeWithProtection(handleClickRefrescarDatosDescuentos)} disabled={isProcessing}>
                    <RefreshIcon className="icon" />
                </IconButton>
            </Tooltip> 
        </Fragment>
    );
}
